import {
  LABOGRUPO_ERROR,
  LABOGRUPO_SUCCESS,
  LABOGRUPO_CENTROS,
  LABOGRUPO_LOADING,
  LABOGRUPO_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import laboGrupoInitialState from "../initialStates/laboGrupoInitialState";

const laboGrupo = (state, { payload, type }) => {
  switch (type) {
    case LABOGRUPO_LOADING:
      return {
        ...state,
        laboGrupo: {
          ...state.laboGrupo,
          error: false,
          loading: true,
        },
      };
    case LABOGRUPO_SUCCESS:
      return {
        ...state,
        laboGrupo: {
          ...state.laboGrupo,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case LABOGRUPO_CENTROS:
      return {
        ...state,
        laboGrupo: {
          ...state.laboGrupo,
          loading: false,
          centros: payload,
        },
      };
    case LABOGRUPO_ERROR:
      return {
        ...state,
        laboGrupo: {
          ...state.laboGrupo,
          error: payload,
          loading: false,
        },
      };

    case LABOGRUPO_RESET:
      return laboGrupoInitialState;
    case RESET_PORTAL_CONTEXT:
      return laboGrupoInitialState;

    default:
      return state;
  }
};

export default laboGrupo;
